import { Controller } from "@hotwired/stimulus"

// Custom file picker: a styled "Choose file" button + a label that
// reflects the picked filename. The native input is hidden via CSS.
// The label target updates when a file is selected.
export default class extends Controller {
  static targets = ["input", "name"]

  updateName() {
    const file = this.inputTarget?.files?.[0]
    if (this.hasNameTarget) {
      this.nameTarget.textContent = file ? file.name : "No file chosen"
    }
  }
}
